module.exports = __webpack_public_path__ + "img/zixun-4.0b75e7a.png";